import { useEffect, useState } from "react"
import { InputAdornment, TextField } from "@mui/material"

const formatFormula = (inputedValue) => {
	if (!inputedValue) return '0'

	let formattedFormula = '';

	// Remove tudo menos numeros e operacoes
	const strippedValue = inputedValue.replace(/^0[,0]+|[,.]+|[^0-9+\-*/,1]+/g,'')

	// Procura valores e separa a formula em operandos se houver
	let matches = [...strippedValue.matchAll(/([0-9.]*[0-9]*,*[0-9]{0,2})([+\-/*])*/g)]
	for (let match of matches) {
		if (match[1] !== '') formattedFormula += formatCurrency(match[1]) + (match[2] ? match[2] : '')
	}

	return formattedFormula
}

const formatCurrency = (inputedValue) => { 
	if (!inputedValue) return '0'
	
	// Remove tudo menos numeros
	let formattedCurrency = inputedValue.replace(/^0[,0]+|[,.]+|[^0-9]+/g,'')

	// Separa decimais de inteiros
	let decimalDigits = formattedCurrency.substring(formattedCurrency.length-2,formattedCurrency.length)
	let integerDigits = formattedCurrency.substring(0, formattedCurrency.length-2)

	// Formata o número
	if (formattedCurrency.length === 0) {
		return ''
	} 
	else if (decimalDigits === '0') {
		return '0,00'
	}
	else if (decimalDigits.length < 2) {
		return '0,0'+ formattedCurrency
	} 
	else if (decimalDigits.length === 2 && integerDigits === '') {
		return '0,'+ formattedCurrency
	}
	else if (formattedCurrency.length < 6) {
		return parseInt(integerDigits) +','+ decimalDigits
	}
	else {
		return integerDigits.split( /(?=(?:\d{3})+(?:,|$))/g ).join( "." ) +','+ decimalDigits;
	}
}

const evalFormula = (formula) => {
	// Remove o ultimo caracter se ele for uma operacao
	let strippedValue	= formula.replace(/[+\-/*]*$/g, '')
	strippedValue		= strippedValue.replace(/\./g, '')
	strippedValue 		= strippedValue.replace(/,/g, '.')

	// Retorna a formula calculada
	return eval(strippedValue)
}

const CurrencyFormulaField = (props) => {

	const {value, adornment, onChange, onBlue, ...otherProps} 	= props
	const [currentValue, setCurrentValue]						= useState(0)

	useEffect(() => {
		setCurrentValue(formatFormula(value))
	}, [value])

	const handleInput = (event) => {
		const formula = formatFormula(event.target.value)
		setCurrentValue(formula)

		event.target.value = formula
		event.target.calculatedValue = evalFormula(formula)
		
		// Sobreescreve o event nos eventos onChange/onBlur, se chamado
		if (props.onChange) props.onChange(event);
	}

	return (
		<TextField 
			value={currentValue}
			onChange={e => handleInput(e)}
			InputProps={{
				startAdornment: <InputAdornment position="start">{(adornment ? adornment : "R$")}</InputAdornment>
			}}
			{...otherProps}
		/>
	)
}

export default CurrencyFormulaField